import { Provider } from "@rcb-plugins/llm-connector";
import OrderService from "@/modules/front/services/OrderService";

// 💡 DŮLEŽITÉ: Třída pro komunikaci s vaším Python serverem
class CustomProxyProvider {
    constructor(backendUrl) {
        this.backendUrl = backendUrl;
    }


    async *sendMessages(messages) {
        // 1. Získání historie z chatu a definic Toolů
        const payload = {
            messages: messages, // Historie konverzace

            // Current user data - (actualy visiting product ?)
            aiLayer: window.aiLayer || {},
        };

        console.log(payload);

        // 2. Volání vašeho AI serveru
        const reponse = await fetch(`${this.backendUrl}/chat`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(response => response.json()
            .then(json => ({ status: response.status, body: json })))
            .then(data => {
                console.log(data);
                console.log(data.body);
                console.log(data.body.command);

                if (data.body.command) {
                    // {'success': True, 'redirect_url': 'http://host.docker.internal:8008/produkt/2', 'type': 'command_redirect'}
                    if (data.body.command.type === 'command_redirect') {
                        setTimeout(() => {
                            window.location.href = data.body.command.redirect_url;
                        }, 50);
                    }
                    if (data.body.command.type === 'command_add_to_cart') {
                        setTimeout(() => {
                            OrderService.addToCart(
                                data.body.command.product_id,
                                data.body.command.date_from,
                                data.body.command.date_to,
                            );
                        }, 50);
                    }
                }

                return data;
            });



       const result = reponse.body.text;
       yield result;
    }
}

export default CustomProxyProvider;